import React, { useEffect } from 'react';
import Header from'../Component/Header'
import { Link } from 'react-router-dom';
const AboutUs = () => {  
  
    useEffect(() => {
        document.title = ' AboutUs - Sacread Heart Kharagpur';  
    }); 
  return (
     <>
     <Header/>
       <div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                  <li>About Us</li>
                  <li>About Us</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1>About Us</h1>
                    </div>
                </div>
                <div className="row">
                     <div className="col-12">
                     <p> After the completion of primary schooling, the children could not carry on with their studies, due to non availability of English medium school, the need for a high school was felt, hence Fr. John Turner with the help of a couple of college going students, began the high school in 1969. </p> <p> St. Agnes School came forward to help the boys of Sacred Heart High School. The newly set up High School was an extension of St. Agnes School. Later Sr. Yvette A.C. became the Principal of the boys section of St. Agnes School; later Fr. John Turner took charge of the school. Land was petitioned from the Railways, different donors came forward with financial help for the construction of the school building, and a huge structure came up. On 10th December 1987 foundation stone was laid for the science block, under the able guidance of Fr Joy. C. DSouza, who was then the Principal. The new block was inaugurated on 16 August 1990 </p> <p> From January 1971, Sacred Heart got separated from St. Agnes boys section, and was recongized as Sacred Heart Higher Secondary School, with science stream. The ISC section with Commerce stream was introduced in 1996; In 2006 the high school began admitting girls. </p> <p> The School is recognized by the Education Department, Government of West Bengal, under the Anglo Indian Board of West Bengal and affiliated to the Council For Indian School Certificate Examinations, New Delhi </p>
 
                    </div>
                </div> 
            </div>
        </div> 
     </>
  )
}

export default AboutUs

